/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_SaveInputs */

const vi_care_log_save = /** @type {(inputs: Care_Log_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu nhật ký`)
};

/**

* @param {Care_Log_SaveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_save = /** @type {((inputs?: Care_Log_SaveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_SaveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_save(inputs)
});